import React, { useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router';
import UIKitMenu from '../../../shared/UIKITComponents/Menu';
import UIKitMenuItem from '../../../shared/UIKITComponents/MenuItem';

interface SubMenuItem {
  text: string;
  to: string;
}

interface Props {
  text: string | React.ReactNode;
  to?: string;
  subItems?: SubMenuItem[];
  className?: string;
}

const TopBarMenuItem: React.FunctionComponent<Props> = (props: Props) => {
  const { text, to, subItems, className } = props;

  const navigate = useNavigate();

  const isMenu = useMemo(() => {
    if (!Array.isArray(subItems)) {
      return false;
    }
    return subItems.length > 0;
  }, [subItems]);

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleToggle = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // el trigger es un <Link/> (para mantener tus clases), pero evitamos navegar
    e.preventDefault();
    setAnchorEl((prev) => (prev ? null : e.currentTarget));
  };

  const handleClose = () => setAnchorEl(null);

  const handleNavigate = (path: string) => {
    handleClose();
    navigate(path);
  };

  // caso simple (sin submenu)
  if (!isMenu) {
    return (
      <Link className={`topbar__nav-link ${className || ''}`} to={to || '/'}>
        {text}
      </Link>
    );
  }

  // caso con submenu
  return (
    <div className={`topbar__collapse ${className || ''}`}>
      <Link
        key="topbar-menu-trigger"
        className="topbar__nav-link"
        to="/"
        onClick={handleToggle}
        aria-haspopup="menu"
        aria-expanded={open ? 'true' : 'false'}
      >
        {text}
      </Link>

      <UIKitMenu
        id={`topbar-menu-${typeof text === 'string' ? text : 'node'}`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        scrollable={false}
        // si querés forzar ancho similar al trigger:
        // menuStyles={{ minWidth: 180 }}
      >
        <div onMouseLeave={handleClose}>
          {(subItems || []).map((x) => (
            <UIKitMenuItem
              key={`topbar-submenu-item-${x.text}`}
              className="topbar-submenu__item-height"
              text={x.text}
              onClick={() => handleNavigate(x.to)}
            />
          ))}
        </div>
      </UIKitMenu>
    </div>
  );
};

export default React.memo(TopBarMenuItem);
